import React, { FC } from 'react'

import { useRoute } from '@react-navigation/native'

import ApplicationProcessContent from './applicationProcessContent'

const ApplicationProcess: FC = () => {
  const { params } = useRoute()

  return <ApplicationProcessContent brandId={params?.brandId} />
}

export default ApplicationProcess
